"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createFallbackFunction(name, context, fallback) {
    if (typeof fallback === 'function') {
        return function () { return fallback(name, context); };
    }
    else if (typeof fallback === 'boolean') {
        return function () { return fallback; };
    }
    else {
        return function () { return false; };
    }
}
exports.createFallbackFunction = createFallbackFunction;
//# sourceMappingURL=helpers.js.map